var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.4 136.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243018;}.cls-2{fill:#6fa331;stroke-width:2px;}.cls-2,.cls-3{stroke:#6fa331;stroke-miterlimit:10;}.cls-3{fill:none;stroke-width:7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26,0h84.4c14.4,0,26,11.6,26,26v84.4c0,14.4-11.6,26-26,26H26c-14.4,0-26-11.6-26-26V26C0,11.6,11.6,0,26,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.2,38.7c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4-2.4,1.1-2.4,2.4,1.1,2.4,2.4,2.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.2,102.3c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4-2.4,1.1-2.4,2.4c0,1.4,1,2.4,2.4,2.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.5,42.8c1.1-.7,1.5-2.1.9-3.3-.7-1.1-2.1-1.5-3.3-.9-1.1.7-1.5,2.1-.9,3.3.7,1.1,2.1,1.5,3.3.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.3,97.9c1.1-.7,1.5-2.1.9-3.3-.7-1.1-2.1-1.5-3.3-.9-1.1.7-1.5,2.1-.9,3.3.7,1.2,2.2,1.6,3.3.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m82.9,42.8c-1.1-.7-1.5-2.1-.9-3.3.7-1.1,2.1-1.5,3.3-.9,1.1.7,1.5,2.1.9,3.3-.7,1.1-2.1,1.5-3.3.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.1,97.9c-1.1-.7-1.5-2.1-.9-3.3.7-1.1,2.1-1.5,3.3-.9,1.1.7,1.5,2.1.9,3.3-.7,1.2-2.2,1.6-3.3.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.7,83c.7-1.1,2.1-1.5,3.3-.9,1.1.7,1.5,2.1.9,3.3-.7,1.1-2.1,1.5-3.3.9s-1.6-2.2-.9-3.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.5,51.2c.7-1.1,2.1-1.5,3.3-.9,1.1.7,1.5,2.1.9,3.3-.7,1.1-2.1,1.5-3.3.9-1.1-.7-1.5-2.2-.9-3.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.5,85.4c.7,1.1,2.1,1.5,3.3.9,1.1-.7,1.5-2.1.9-3.3-.7-1.1-2.1-1.5-3.3-.9-1.1.7-1.5,2.1-.9,3.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.8,68.3c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4,1.1,2.4,2.4,2.4,2.4-1.1,2.4-2.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.4,68.3c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4,1.1,2.4,2.4,2.4c1.4,0,2.4-1.1,2.4-2.4Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "54.5 64.7 68.2 78.8 110.3 35.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTime);
export default __webpack_public_path__ + "static/media/real_time.e96f00efe9ad28c1df14716d9a65b70f.svg";
export { ForwardRef as ReactComponent };